<template>
  <li v-theme-bg-hover :class="checkActionState(index)" @click="clickAction(action)">
    <a v-if="action.url" :href="action.url" target="_blank" class="external">{{ action.text }}</a>
    <template v-if="!action.url">{{ action.text }}</template>
  </li>
</template>

<script>
export default {
  props: {
    action: { type: Object, required: true },
    index: { type: Number, required: true },
    checkActionState: { type: Function, required: true },
    clickAction: { type: Function, required: true }
  }
}
</script>
